import moment from "moment";
import { occupations, membershipTypes, countries } from "../constants";
import { findGetParameter, clear } from "./form-utils";

const sectors = {
    private: 0,
    kommunal: 1,
    handel: 2,
    stat: 3,
    none: undefined,
};

const trueLabel = "true";

const setFlagsAffectingFlow = (formValues, mergedFormValues) => {
    let flags = {};
    mergedFormValues =
        mergedFormValues != undefined ? mergedFormValues : formValues;

    const setFormValue = (key, value) => {
        formValues[key] = value;
        mergedFormValues[key] = value;
    };

    ///////////////////////////////////////////////////////////
    //MEMBERSHIPTYPE
    ///////////////////////////////////////////////////////////

    let skipAkasse =
        findGetParameter("SkipAkasse") === trueLabel ||
        findGetParameter("SkipAkasseFlag") === trueLabel
            ? true
            : false;
    let skipUnion =
        findGetParameter("SkipUnion") === trueLabel ||
        findGetParameter("SkipUnionFlag") === trueLabel ||
        mergedFormValues.IsAkasseOnlyMOS === true
            ? true
            : false;

    if (skipUnion === true) {
        flags.SkipUnionFlag = true;
        setFormValue("SkipUnionFromURL", true);
        setFormValue("MembershipType", membershipTypes.UnemploymentFund);
    } else if (skipAkasse === true) {
        flags.SkipAkasseFlag = true;
        setFormValue("SkipAkasseFromURL", true);
        setFormValue("MembershipType", membershipTypes.Union);
    } else {
        switch (mergedFormValues.MembershipType) {
            case membershipTypes.Union: {
                flags.SkipAkasseFlag = true;
                flags.SkipUnionFlag = false;
                break;
            }
            case membershipTypes.UnemploymentFund: {
                flags.SkipUnionFlag = true;
                flags.SkipAkasseFlag = false;
                break;
            }
            case membershipTypes.UnionAndUnemploymentFund: {
                flags.SkipAkasseFlag = false;
                flags.SkipUnionFlag = false;
            }
        }
    }

    ///////////////////////////////////////////////////////////
    //UNDEREDUCATION
    ///////////////////////////////////////////////////////////
    let underEducation =
        findGetParameter("undereducation") === trueLabel ||
        mergedFormValues.IsStudyPlusMOS === true
            ? true
            : false;
    if (underEducation === true) {
        flags.UnderEducationFlag = true;
        setFormValue("UnderEducationFlag", true);
    } else {
        flags.UnderEducationFlag = false;
        setFormValue("UnderEducationFlag", false);
    }

    ///////////////////////////////////////////////////////////
    //EDUCATION
    ///////////////////////////////////////////////////////////

    //Vi laver en string værdi med uddannelsesnavnet som backenden kan læse.
    if (mergedFormValues.EducationChoice) {
        setFormValue(
            "EducationChoiceName",
            mergedFormValues.EducationChoice.Education
        );
    } else {
        setFormValue("EducationChoiceName", undefined);
    }

    //Fix - Sørger for at nulstille educationchoicemanual hvis man nu er gået tilbage og har ændret så man godt kan finde sin uddannelse
    if (
        mergedFormValues.EducationChoice &&
        mergedFormValues.EducationChoiceManual
    ) {
        if (mergedFormValues.EducationChoice.CrmId) {
            setFormValue("EducationChoiceManual", undefined);
        }
    }

    //Fix - Sørger for at nulstille educationchoiceafterfinishededucationmanual hvis man nu er gået tilbage og har ændret så man godt kan finde sin uddannelse
    if (
        mergedFormValues.EducationChoiceAfterFinishedEducation &&
        mergedFormValues.EducationChoiceAfterFinishedEducationManual
    ) {
        if (mergedFormValues.EducationChoiceAfterFinishedEducation.CrmId) {
            setFormValue(
                "EducationChoiceAfterFinishedEducationManual",
                undefined
            );
        }
    }

    //Sæt flag der relaterer sig til udd. afslutningsdato
    if (
        mergedFormValues.EducationEndDate !== null &&
        mergedFormValues.EducationEndDate !== "" &&
        mergedFormValues.EducationEndDate !== undefined
    ) {
        setFormValue(
            "EducationEndDate",
            moment(mergedFormValues.EducationEndDate)
                .startOf("day")
                .format("YYYY-MM-DD")
        );

        flags.GraduatedWithinLast14DaysFlag = moment(
            mergedFormValues.EducationEndDate
        )
            .startOf("day")
            .isBetween(
                moment().subtract(14, "days").startOf("day"),
                moment().startOf("day"),
                "day",
                "[]"
            );
        flags.Student15MonthsPlusRuleFlag = moment(
            mergedFormValues.EducationEndDate
        )
            .startOf("day")
            .isAfter(moment().add(15, "months"), "day");
        flags.Student3MonthsPlusRuleFlag = moment(
            mergedFormValues.EducationEndDate
        )
            .startOf("day")
            .isAfter(moment().add(3, "months"), "day");
        flags.Graduated = moment(mergedFormValues.EducationEndDate)
            .startOf("day")
            .isBefore(moment(), "day");
        flags.Under3MonthsTillEducationEndFlag = moment(
            mergedFormValues.EducationEndDate
        )
            .startOf("day")
            .isBetween(
                moment().startOf("day"),
                moment().add(3, "months").endOf("day"),
                "day",
                "(]"
            );

        setFormValue(
            "GraduatedWithinLast14DaysFlag",
            flags.GraduatedWithinLast14DaysFlag
        );
        setFormValue(
            "Student15MonthsPlusRuleFlag",
            flags.Student15MonthsPlusRuleFlag
        );
        setFormValue(
            "Student3MonthsPlusRuleFlag",
            flags.Student3MonthsPlusRuleFlag
        );
        setFormValue("Graduated", flags.Graduated);
        setFormValue(
            "Under3MonthsTillEducationEndFlag",
            flags.Under3MonthsTillEducationEndFlag
        );
    }

    //Nulstil hvis ikke sat
    else if (
        mergedFormValues.EducationEndDate === null ||
        mergedFormValues.EducationEndDate === "" ||
        mergedFormValues.EducationEndDate === undefined
    ) {
        setFormValue("EducationEndDate", undefined);
        setFormValue("Student3MonthsPlusRuleFlag", false);
        setFormValue("Student15MonthsPlusRuleFlag", false);
        setFormValue("Graduated", false);
        setFormValue("Under3MonthsTillEducationEndFlag", false);
        setFormValue("IsRecentGraduate", false);

        flags.Student15MonthsPlusRuleFlag = false;
        flags.Student3MonthsPlusRuleFlag = false;
        flags.Graduated = false;
        flags.Under3MonthsTillEducationEndFlag = false;
        flags.RecentGraduateFlag = false;

        if (!mergedFormValues.UnderFourteenDaysSinceEducationEnd) {
            flags.GraduatedWithinLast14DaysFlag = false;
            setFormValue("GraduatedWithinLast14DaysFlag", false);
        }
    }

    //Her tjekker vi om man manuelt har svaret at der er under 14 dage siden man har afsluttet sin uddannelse. Dette er relevant for at kunne vise en mere korrekt pris under membershiptype steppet.
    if (
        !mergedFormValues.EducationEndDate &&
        mergedFormValues.UnderFourteenDaysSinceEducationEnd
    ) {
        flags.GraduatedWithinLast14DaysFlag = true;
        setFormValue("GraduatedWithinLast14DaysFlag", true);
    } else if (
        !mergedFormValues.EducationEndDate &&
        !mergedFormValues.UnderFourteenDaysSinceEducationEnd
    ) {
        flags.GraduatedWithinLast14DaysFlag = false;
        setFormValue("GraduatedWithinLast14DaysFlag", false);
    }

    if (
        mergedFormValues.EducationChoice &&
        mergedFormValues.EducationChoice.DunCode !== "0" &&
        !mergedFormValues.EducationChoiceManual
    ) {
        flags.HKEducationFlag = mergedFormValues.EducationChoice.IsHKEducation;
        flags.PracticalEducationFlag =
            mergedFormValues.EducationChoice.IsPractical;
        flags.TheoreticalEducationFlag =
            mergedFormValues.EducationChoice.IsTheoretical;
        flags.BasicEducationFlag = mergedFormValues.EducationChoice.IsBasic;
        flags.PrimarySchoolFlag = mergedFormValues.EducationChoice.IsFolkeskole;

        if (mergedFormValues.EducationChoice.IsPractical) {
            setFormValue("ManagementResponsibilityFromCode", "1"); //"Elever og lærlinge" is always the choice for Praktiske Elever
            setFormValue("Over30HoursFromCode", true); //30+ hours is always the choice for Praktiske Elever
        } else {
            setFormValue("ManagementResponsibilityFromCode", undefined); //"Elever og lærlinge" is always the choice for Praktiske Elever
            setFormValue("Over30HoursFromCode", false); //30+ hours is always the choice for Praktiske Elever
        }

        //Flag sættes hvis man er på en dimmitentberettiget uddannelse eller er på en uddannelse der er en del af en dimmitentberettiget uddannelse (Eksempelvis mediegrafiker basisuddannelse)
        if (
            mergedFormValues.EducationChoice.DimittendBerettiget === true ||
            mergedFormValues.EducationChoice
                .IsPartOfDimittendBerettigetUddannelse === true
        ) {
            flags.PartOfOrGraduationEntitledFlag = true;
        } else {
            flags.PartOfOrGraduationEntitledFlag = false;
        }
    }
    //Hvis din uddannelse er indtastet manuelt får du teoretisk/praktisk medlemstilstand efter hvilken situation du har valgt, og ikke direkte fra udd. databasen
    //Indmeldelsen bliver også sendt til manuel behandling med en kommentar i feltet.
    else if (
        mergedFormValues.EducationChoiceManual &&
        (mergedFormValues.MemberSituation === occupations.student ||
            mergedFormValues.MemberSituation === occupations.trainee ||
            mergedFormValues.MemberSituation ===
                occupations.vocationalEducation)
    ) {
        flags.ProcessManuallyFlag = true;
        flags.HKEducationFlag = false;
        flags.BasicEducationFlag = false;
        flags.PrimarySchoolFlag = false;
        flags.PartOfOrGraduationEntitledFlag = false;
        setFormValue("ManagementResponsibilityFromCode", undefined); //"Elever og lærlinge" is always the choice for Praktiske Elever
        setFormValue("Over30HoursFromCode", false); //30+ hours is always the choice for Praktiske Elever

        switch (mergedFormValues.MemberSituation) {
            case occupations.student:
                flags.TheoreticalEducationFlag = true;
                flags.PracticalEducationFlag = false;
                break;
            case occupations.vocationalEducation:
                flags.PracticalEducationFlag = true;
                flags.TheoreticalEducationFlag = false;
                break;
        }
    } else {
        flags.HKEducationFlag = false;
        flags.PracticalEducationFlag = false;
        flags.TheoreticalEducationFlag = false;
        flags.BasicEducationFlag = false;
        flags.PrimarySchoolFlag = false;
        flags.PartOfOrGraduationEntitledFlag = false;
        flags.ProcessManuallyFlag = false;
        setFormValue("ManagementResponsibilityFromCode", undefined); //"Elever og lærlinge" is always the choice for Praktiske Elever
        setFormValue("Over30HoursFromCode", false); //30+ hours is always the choice for Praktiske Elever
    }

    if (mergedFormValues.StartNewEducation) {
        flags.StartedNewEducationFlag = true;
    } else {
        flags.StartedNewEducationFlag = false;
    }

    ///////////////////////////////////////////////////////////
    //RECENTGRADUATE
    ///////////////////////////////////////////////////////////

    //Logik der relaterer sig til RecentGraduate.
    //RecentGraduate betyder her at man er dimmitentberettiget
    if (
        mergedFormValues.EducationEndDate !== null &&
        mergedFormValues.EducationEndDate !== "" &&
        mergedFormValues.EducationEndDate !== undefined
    ) {
        //Sæt som recentgraduate hvis (Er udlært, men under 14 dage siden) ELLER (Ikke udlært, men under 3 måneder tilbage)
        //Det er kun for dimmitentberettigede uddannelser
        if (
            ((mergedFormValues.Graduated === true &&
                mergedFormValues.GraduatedWithinLast14DaysFlag === true) ||
                (!mergedFormValues.Graduated &&
                    !mergedFormValues.Student3MonthsPlusRuleFlag)) &&
            mergedFormValues.MemberSituation !== occupations.trainee &&
            mergedFormValues.EducationChoice &&
            mergedFormValues.EducationChoice.IsHKEducation &&
            mergedFormValues.EducationChoice.DimittendBerettiget
        ) {
            setFormValue("IsRecentGraduate", true);
            flags.RecentGraduateFlag = true;
        }

        //Hvis brugeren indtaster en uddannelses slutdato der enten er mindre end 14 dage siden eller der er under 3 måneder til,
        //Men efterfølgende forttyder og går tilbage og sætter en anden sluddato skal vi nulstille så man ikke er recentgraduate mere.
        //Dette gøres herunder
        //Vi tjekker på om man er recentgraduate, og om det på trods af det hverken er inden for de seneste 14 dage man er udlært eller der er under 3 måneder til. Dette kan nemlig kun lade sig gøre hvis man har fortrudt og efterfølgende har ændret sin slutdato
        else if (mergedFormValues.IsRecentGraduate) {
            setFormValue("IsRecentGraduate", false);
            flags.RecentGraduateFlag = false;
        }
    }

    //Vi spørger først efter valg om uddannelsesvalg om man har haft bopæl gennem hele uddannelsen i DK. Hvis man ikke har kan man ikke få dimmitentdagpenge og er altså ikke recentgraduate
    if (mergedFormValues.HasResidence === false) {
        flags.RecentGraduateFlag = false;
        setFormValue("IsRecentGraduate", false);
    }

    if (
        mergedFormValues.EducationChoiceAfterFinishedEducation?.IsPractical ===
            true &&
        mergedFormValues.StartNewEducation
    ) {
        setFormValue("StartNewEducationIsPractical", true);
    } else {
        setFormValue("StartNewEducationIsPractical", false);
    }

    ///////////////////////////////////////////////////////////
    //Membersituation
    ///////////////////////////////////////////////////////////

    if (mergedFormValues.MemberSituation) {
        switch (mergedFormValues.MemberSituation) {
            case occupations.employed:
                flags.EmployedFlag = true;
                flags.StudentPupilFlag = false;
                flags.TraineeFlag = false;
                flags.UnemployedFlag = false;
                flags.SelfEmployedFlag = false;

                break;
            case occupations.student:
                flags.StudentPupilFlag = true;
                flags.EmployedFlag = false;
                flags.TraineeFlag = false;
                flags.UnemployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.trainee:
                flags.TraineeFlag = true;
                flags.StudentPupilFlag = false;
                flags.EmployedFlag = false;
                flags.UnemployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.unemployed:
                flags.UnemployedFlag = true;
                flags.TraineeFlag = false;
                flags.StudentPupilFlag = false;
                flags.EmployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.vocationalEducation:
                flags.StudentPupilFlag = true;
                flags.UnemployedFlag = false;
                flags.TraineeFlag = false;
                flags.EmployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.selfEmployed:
                flags.SelfEmployedFlag = true;
                flags.StudentPupilFlag = false;
                flags.UnemployedFlag = false;
                flags.TraineeFlag = false;
                flags.EmployedFlag = false;
                break;
        }
    }

    ///////////////////////////////////////////////////////////
    //A-KASSE / UNEMPLOYMENT-FUND
    ///////////////////////////////////////////////////////////

    if (mergedFormValues.ReceivesWageSubsidies) {
        flags.FlexiJobFlag = true;
    } else {
        flags.FlexiJobFlag = false;
    }

    if (
        mergedFormValues.SolidarityDuesEligible ||
        mergedFormValues.ReceivesWageSubsidies ||
        ((mergedFormValues.Country === countries.Faeroerne ||
            mergedFormValues.Country === countries.Groendland) &&
            mergedFormValues.MemberSituation &&
            mergedFormValues.MemberSituation != occupations.student &&
            mergedFormValues.MemberSituation != occupations.trainee &&
            mergedFormValues.MemberSituation != occupations.vocationalEducation)
    ) {
        flags.SolidarityDuesEligibleFlag = true;
    } else {
        flags.SolidarityDuesEligibleFlag = false;
    }

    //Salary Insurance
    if (
        (mergedFormValues.Country === countries.Faeroerne ||
            mergedFormValues.Country === countries.Groendland) &&
        mergedFormValues.MemberSituation &&
        mergedFormValues.MemberSituation != occupations.student &&
        mergedFormValues.MemberSituation != occupations.trainee &&
        mergedFormValues.MemberSituation != occupations.vocationalEducation
    ) {
        flags.MaybeHasSalaryInsuranceFlag = false;
    } else if (
        mergedFormValues.SalaryInsurance === "HasSalaryInsurance" ||
        mergedFormValues.SalaryInsurance === "NoKnowledgeOfSalaryInsurance"
    ) {
        flags.MaybeHasSalaryInsuranceFlag = true;
    } else {
        flags.MaybeHasSalaryInsuranceFlag = false;
    }

    //Hvis MonethlyIncomeReason er true betyder det at brugeren har svaret at de er på revalidering når spørgsmålet om hvorfor deres indkomst er over akassengrænsen bliver besvaret.
    //Hvis RecievesPublicWelfare er true betyder det at brugeren har svaret ja til at være på offentlig forsørgelse
    if (
        mergedFormValues.MonthlyIncomeLimitClarification === true ||
        mergedFormValues.RecievesPublicWelfare === true
    ) {
        flags.SalaryContributionFlag = true;
    } else {
        flags.SalaryContributionFlag = false;
    }

    //Hvis brugeren har bedt om et deltidsmedlemskab i akasseflow sættes flaget for deltids akassemedlemsskab her.
    if (mergedFormValues.PartTimeMembership !== undefined) {
        switch (mergedFormValues.PartTimeMembership) {
            case trueLabel:
                flags.PartTimeMembershipFlag = true;
                break;
            default:
                flags.PartTimeMembershipFlag = false;
                break;
        }
    } else if (
        mergedFormValues.MembershipType === membershipTypes.Union &&
        mergedFormValues.Over30Hours === false &&
        !mergedFormValues.Over30HoursFromCode
    ) {
        flags.PartTimeMembershipFlag = true;
    } else {
        flags.PartTimeMembershipFlag = false;
    }

    if (mergedFormValues.HasWork) {
        flags.AcquiredJobFlag = true;
    } else {
        flags.AcquiredJobFlag = false;
    }

    if (mergedFormValues.MonthlyIncomeOverLimit) {
        flags.EarnsOver18KFlag = true;
    } else {
        flags.EarnsOver18KFlag = false;
    }

    if (mergedFormValues.SalaryFromOtherThanEmployer) {
        flags.StudentExtraIncomeFlag = true;
    } else {
        flags.StudentExtraIncomeFlag = false;
    }

    if (mergedFormValues.BenefitsEntitledFromOtherAkasse) {
        flags.BenefitsEntitledFromOtherAkasseFlag = true;
    } else {
        flags.BenefitsEntitledFromOtherAkasseFlag = false;
    }

    if (mergedFormValues.AkasseReducedMembershipFee) {
        flags.AkasseReducedMembershipFeeFlag = true;
    } else {
        flags.AkasseReducedMembershipFeeFlag = false;
    }

    if (mergedFormValues.HasUnemploymentInsuranceFund) {
        flags.MemberOfOtherAkasseFlag = true;
    } else {
        flags.MemberOfOtherAkasseFlag = false;
    }

    if (mergedFormValues.HasPreviousUnemploymentInsuranceFund) {
        flags.FormerMemberOfOtherAkasseFlag = true;
    } else {
        flags.FormerMemberOfOtherAkasseFlag = false;
    }

    ///////////////////////////////////////////////////////////
    //MISC-FLAGS
    ///////////////////////////////////////////////////////////
    if (mergedFormValues.Workplace && mergedFormValues.Workplace.CrmId) {
        flags.EmployerCrmId = mergedFormValues.Workplace.CrmId;
    } else {
        flags.EmployerCrmId = undefined;
    }

    if (mergedFormValues.WorkplaceEnteredManually) {
        flags.ManualWorkplaceFlag = true;
    } else {
        flags.ManualWorkplaceFlag = false;
    }

    //For at kunne parse rigtigt i backenden skal vi lave en membershipstartdate der er i iso format
    if (mergedFormValues.MembershipStartDate) {
        setFormValue(
            "MembershipStartDateIso",
            moment(mergedFormValues.MembershipStartDate)
                .startOf("day")
                .format("YYYY-MM-DD")
        );
    } else {
        setFormValue("MembershipStartDateIso", undefined);
    }

    if (mergedFormValues.StudyJob === true) {
        flags.AfterSchoolJobFlag = true;
    } else {
        flags.AfterSchoolJobFlag = false;
    }

    if (mergedFormValues.Age >= 30) {
        flags.IsOver30Flag = true;
    } else {
        flags.IsOver30Flag = false;
    }

    //Hvis brugeren i akasseflow har indtastet at de ikke har over 30 timer. Hvis man har svaret dette skal flaget for deltidsansættelse sættes højt.
    if (
        mergedFormValues.Over30Hours === false &&
        !mergedFormValues.Over30HoursFromCode
    ) {
        flags.PartTimeEmploymentFlag = true;
    } else if (
        mergedFormValues.Over30Hours === true ||
        mergedFormValues.Over30HoursFromCode === true
    ) {
        flags.PartTimeEmploymentFlag = false;
    }

    ///////////////////////////////////////////////////////////
    //SAMTYKKER
    ///////////////////////////////////////////////////////////
    if (mergedFormValues.ConsentRecieveOffersFromBusinessPartners) {
        flags.ThirdPartyConsentFlag = true;
    } else {
        flags.ThirdPartyConsentFlag = false;
    }

    if (mergedFormValues.ConsentRecieveFromUnemploymentFund) {
        flags.AkasseThirdPartyConsentFlag = true;
    } else {
        flags.AkasseThirdPartyConsentFlag = false;
    }

    if (mergedFormValues.IsRecentGraduate && mergedFormValues.HasWork) {
        flags.Sector = sectors.none;
    } else if (
        mergedFormValues.EducationChoiceManual ||
        mergedFormValues.CompanyName ||
        mergedFormValues.CompanyCvr ||
        (mergedFormValues.EducationChoice &&
            mergedFormValues.EducationChoice.IsHKEducation)
    ) {
        flags.Sector = sectors.private;
    } else {
        flags.Sector = sectors.none;
    }

    return flags;
};

// Prepare data for backend
function mapFormData(formValues, step, mergedFormValues) {
    return {
        Component: step.Component,
        Variant: step.Variant,
        ...setFlagsAffectingFlow(formValues, mergedFormValues),
        formValues: Object.assign({}, formValues),
    };
}

export default mapFormData;
